module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main"
  }, [_c('download-Popup'), _vm._v(" "), _c('div', {
    staticClass: "topFixedWrap",
    attrs: {
      "id": "topFixed"
    }
  }, [(_vm.isOperamini) ? _c('p', {
    staticClass: "operamini-tips"
  }, [_vm._v("Untuk memberi Anda pengalaman yang lebih baik, silakan unduh\n            aplikasi profesional kami.")]) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "navBread"
  }, [_c('a', {
    staticClass: "match",
    attrs: {
      "href": "/matchs"
    }
  }, [_vm._v("Match")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": '/matchs/' + _vm.subtitleName,
      "id": "matchSubtitJump"
    }
  }, [_vm._v(_vm._s(_vm.subtitleName))])]), _vm._v(" "), _c('div', {
    staticClass: "bannerInformWrap clearfix",
    attrs: {
      "id": "teamWrap"
    }
  }, [_c('div', {
    staticClass: "banner-left"
  }, [_c('img', {
    directives: [{
      name: "team-logo",
      rawName: "v-team-logo"
    }],
    staticClass: "team-logo",
    attrs: {
      "src": _vm.getImgSrc(_vm.idData.team_A_logo),
      "alt": _vm.idData.team_A_name
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "team-name"
  }, [_vm._v(_vm._s(_vm.idData.team_A_name))])]), _vm._v(" "), _c('div', {
    staticClass: "bannerCenterWrap"
  }, [(_vm.competeStatus === 'Played') ? _c('div', {
    staticClass: "w-full status_ended"
  }, [_c('p', {
    staticClass: "competename"
  }, [_vm._v(_vm._s(_vm.idData.competition_name))]), _vm._v(" "), _c('div', {
    staticClass: "scorewrap clearfix"
  }, [_c('span', {
    staticClass: "ml15"
  }, [_vm._v(_vm._s(_vm.idData.fs_A))]), _c('b', {
    staticClass: "rowLine"
  }), _c('span', [_vm._v(_vm._s(_vm.idData.fs_B))])]), _vm._v(" "), _c('p', {
    staticClass: "time"
  }, [_vm._v(_vm._s(_vm.local_month_day) + " " + _vm._s(_vm.tran12(_vm.local_hour_minite)))])]) : _vm._e(), _vm._v(" "), (_vm.competeStatus === 'Playing') ? _c('div', {
    staticClass: "w-full status_playing"
  }, [_c('p', {
    staticClass: "competename"
  }, [_vm._v("\n                        " + _vm._s(_vm.idData.competition_name) + "\n                        "), (_vm.idData.livingFlag) ? _c('span', {
    staticClass: "text-green"
  }, [_vm._v(_vm._s(_vm.idData.minute) + "'")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "scorewrap clearfix"
  }, [_c('span', {
    staticClass: "ml15"
  }, [_vm._v(_vm._s(_vm.idData.fs_A))]), _vm._v(" "), _c('b', {
    staticClass: "rowLine"
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.idData.fs_B))])]), _vm._v(" "), (_vm.matchTagFormation.type) ? _c('AppMatchTag', {
    attrs: {
      "type": _vm.matchTagFormation.type
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.idData.livingFlag) ? _c('p', {
    staticClass: "unlive"
  }, [_vm._v(_vm._s(_vm.idData.minute) + "'")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.competeStatus === 'Fixture') ? _c('div', {
    staticClass: "status_unstart"
  }, [_c('p', {
    staticClass: "competename"
  }, [(_vm.idData.livingFlag) ? [_vm._v(_vm._s(_vm.local_month_day) + " " + _vm._s(_vm.tran12(_vm.local_hour_minite)))] : _vm._e(), _vm._v("\n                        " + _vm._s(_vm.idData.competition_name) + "\n                    ")], 2), _vm._v(" "), _c('p', {
    staticClass: "vs"
  }, [_vm._v("VS")]), _vm._v(" "), (_vm.matchTagFormation.type) ? _c('AppMatchTag', {
    attrs: {
      "type": _vm.matchTagFormation.type
    }
  }) : _c('div', {
    staticClass: "unstartTime clearfix"
  }, [_c('span', {
    staticClass: "time"
  }, [_vm._v(_vm._s(_vm.local_month_day) + " " + _vm._s(_vm.tran12(_vm.local_hour_minite)))])])], 1) : _vm._e(), _vm._v(" "), (_vm.competeStatus === 'Postponed' || _vm.competeStatus === 'Cancelled' || _vm.competeStatus === 'Suspended') ? _c('div', {
    staticClass: "status_unstart"
  }, [_c('p', {
    staticClass: "competename"
  }, [_vm._v(_vm._s(_vm.idData.competition_name))]), _vm._v(" "), _c('p', {
    staticClass: "vs"
  }, [_vm._v("VS")]), _vm._v(" "), _c('div', {
    staticClass: "unstartTime clearfix"
  }, [_c('span', {
    staticClass: "time"
  }, [_vm._v(_vm._s(_vm.competeStatus))])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "banner-right"
  }, [_c('img', {
    directives: [{
      name: "team-logo",
      rawName: "v-team-logo"
    }],
    staticClass: "team-logo",
    attrs: {
      "alt": _vm.idData.team_B_name,
      "src": _vm.getImgSrc(_vm.idData.team_B_logo)
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "team-name"
  }, [_vm._v(_vm._s(_vm.idData.team_B_name))])])]), _vm._v(" "), _c('div', {
    staticClass: "tabWrap"
  }, [_c('span', {
    class: {
      'selected': _vm.toggleSelect === 'Ikhtisar'
    },
    on: {
      "click": function($event) {
        _vm.toggle('Ikhtisar')
      }
    }
  }, [_vm._v("Ikhtisar")]), _vm._v(" "), _c('span', {
    class: {
      'selected': _vm.toggleSelect === 'Analisis'
    },
    on: {
      "click": function($event) {
        _vm.toggle('Analisis')
      }
    }
  }, [_vm._v("Analysis")]), _vm._v(" "), _c('span', {
    class: {
      'selected': _vm.toggleSelect === 'Live'
    },
    on: {
      "click": function($event) {
        _vm.toggle('Live')
      }
    }
  }, [_vm._v("Langsung HD")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentWrap",
    attrs: {
      "id": "contentWrap"
    }
  }, [_c('match-overview', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.toggleSelect === 'Ikhtisar'),
      expression: "toggleSelect === 'Ikhtisar'"
    }],
    staticClass: "tabContent",
    attrs: {
      "matchId": _vm.competeId
    }
  }), _vm._v(" "), _c('match-analysis', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.toggleSelect === 'Analisis'),
      expression: "toggleSelect === 'Analisis'"
    }],
    staticClass: "tabContent",
    attrs: {
      "matchId": _vm.competeId
    }
  }), _vm._v(" "), _c('match-live', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.toggleSelect === 'Live'),
      expression: "toggleSelect === 'Live'"
    }],
    style: ({
      height: _vm.contentHeight
    }),
    attrs: {
      "matchId": _vm.competeId
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3b61b811","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/AppMatchDetail.vue
// module id = 707
// module chunks = 1